module.exports = __webpack_public_path__ + "static/media/declineIcon.ac0a1bb9.svg";